module.exports = __webpack_public_path__ + "img/soporte_hover.b0aedb3b.png";